export enum TaskActionTypes {
  INIT_TODAY_TASK_LISTENER = '[Task] Init today task listener',
  STOP_TODAY_TASK_LISTENER = '[Task] Stop today task listener',
}
